import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectGlobalOrgRegistryMappingsListItems } from "../../../../../redux/global-org-registry-mappings/selector";
import { globalOrgRegistryMappings } from "../../../../../redux/global-org-registry-mappings/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";


const GlobalOrgRegistrationMappingDetails = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
    const dbnpMappingItems = useSelector(selectGlobalOrgRegistryMappingsListItems)
    const [storedItems, setStoredItems] = useState<any>({});

    useEffect(() => {
        const storedValue = localStorage.getItem('storageKey');
        if (storedValue) {
            try {
                const parsedValue = JSON.parse(storedValue);
                setStoredItems(parsedValue.items || []);
            } catch (error) {
                console.error("Error parsing JSON from localStorage:", error);
            }
        } else {
            console.log("No stored value found");
        }
    }, []);
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'InternalDBNIEName', headerName: 'Internal DBNIE Name'},
          { field: 'InternalDBNPName', headerName: 'Internal DBNP Name'},
          { field: 'GlobalOrgRegistryDBNIEName', headerName: 'Global Org Registry DBNIE Name'},
          { field: 'GlobalOrgRegistryDBNPName', headerName: 'Global Org Registry DBNP',searchField: 'GlobalProviderDBNPName', filter: true,
            filterType: 'text'}, 
            { field: 'GlobalOrgRegistryName', headerName: 'Global Org Registry  Name',searchField: 'GlobalProviderDBNPName', filter: true,
              filterType: 'text'}, 
      
        ]);
      }
      const fetchDbnpMapping=()=>{

        dispatch(globalOrgRegistryMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/fetch`,entity:'globalOrgRegistryMappings',jsonData:{
            "Context": {},
            "Records": [
              {
                GlobalOrgRegistryId: storedItems?.Id
              }
            ],
            "Pagination": {
              PageNumber: 1,
              PageSize: 50,
              SortField: 'Id',
              SortOrder: 'desc',
            },
      }}))
       
      }
      const handleDelete=(data: any)=>{
        dispatch(globalOrgRegistryMappings.delete({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/delete`,
          entity: 'globalOrgRegistryMappings',
          jsonData: {
              Records: [
                  {
                      GlobalOrgRegistryId: storedItems?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(globalOrgRegistryMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registry-mappings/list`,entity:'globalOrgRegistryMappings',jsonData:{
            "Context": {},
            "Records": [
              {
                GlobalOrgRegistryId: storedItems?.Id
              }
            ],
            "Pagination": {
              PageNumber: 1,
              PageSize: 50,
              SortField: 'Id',
              SortOrder: 'desc',
            },
      }}))
      });
      }
 
	useEffect(() => {
    if(storedItems?.Id){
        createColumnDefs()
        fetchDbnpMapping()
    }
	}, [pageData,pageSize,storedItems])
  
	return (
     <>
     {dbnpMappingItems?.isLoading ? 
      <PageLoader />
  : 
     <Table enableFilter={true}
     columnData={columnDefs} rowData={dbnpMappingItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
     paginationData={dbnpMappingItems?.result?.pagination} onDelete={handleDelete} headingName="Global Org Registry Mappings" />
}
     </>
		
       
     
	);
};

export default GlobalOrgRegistrationMappingDetails;


